import React from 'react'
import faker from 'faker/locale/en_AU'

import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import Icon from '@material-ui/core/Icon'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'

import PageLayout from 'components/Layout/PageLayout'

import styles from './styles'
import arrayToCsv from 'helpers/file/array-to-csv'
import dateTimeString from 'helpers/generators/date-time-string'

class ProviderList extends React.Component {
  state = {
    fields: {},
    quantity: 100,
    searchString: ''
  }

  categories = [
    'address',
    'commerce',
    'company',
    'database',
    'date',
    'finance',
    'hacker',
    'image',
    'internet',
    'lorem',
    'name',
    'phone',
    'random',
    'system'
  ]

  handleChange = key => event => {
    this.setState({ [key]: event.target.value })
  }

  handlePickField = (category, key) => event => {
    const comboKey = `${category}.${key}`
    this.setState((prevState, props) => ({
      fields: {
        ...prevState.fields,
        [comboKey]: !Boolean(prevState.fields[comboKey])
      }
    }))
  }

  generate = () => {
    const generatedData = Array(+this.state.quantity)
      .fill('')
      .map(() =>
        Object.entries(this.state.fields).reduce(
          (accumulator, [comboKey, value]) => {
            if (value) {
              const [category, key] = comboKey.split('.')
              accumulator[key] = faker[category][key]()
            }
            return accumulator
          },
          {}
        )
      )

    arrayToCsv(generatedData, `${dateTimeString()} - Generated Data`)
  }

  render() {
    const { fields, searchString, quantity } = this.state
    const { classes } = this.props

    return (
      <PageLayout title="Data Generator" slim>
        <Grid container spacing={24}>
          <Grid item xs={12} md={8}>
            <TextField
              label="Search"
              type="search"
              value={this.state.searchString}
              onChange={this.handleChange('searchString')}
              fullWidth
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              type="number"
              label="Row Quantity"
              value={quantity}
              onChange={this.handleChange('quantity')}
              fullWidth
              margin="normal"
            />
          </Grid>
        </Grid>
        <List>
          {this.categories.map(category => {
            return (
              <div key={category}>
                <ListSubheader component="div">{category}</ListSubheader>
                {Object.keys(faker[category]).map(key => {
                  return (
                    key.toLowerCase().includes(searchString.toLowerCase()) && (
                      <ListItem
                        key={key}
                        button
                        onClick={this.handlePickField(category, key)}
                      >
                        <Checkbox
                          checked={Boolean(fields[`${category}.${key}`])}
                          onClick={() => {}}
                          tabIndex={-1}
                          disableRipple
                        />
                        <ListItemText primary={key} />
                      </ListItem>
                    )
                  )
                })}
              </div>
            )
          })}
        </List>

        <Button
          className={classes.generateButton}
          variant="fab"
          color="secondary"
          aria-label="add"
          onClick={this.generate}
        >
          <Icon>file_download</Icon>
        </Button>
      </PageLayout>
    )
  }
}

export default withStyles(styles, { withTheme: true })(ProviderList)



// WEBPACK FOOTER //
// ./src/views/DataGenerator/Main/index.jsx